<form [formGroup]="companyForm" *ngIf="companyForm">
  <ion-item>
    <ion-input
      class="ion-text-right"
      formControlName="name"
      [label]="'COMPANY.COMPANY_NAME' | translate"
      [placeholder]="'COMPANY.COMPANY_NAME_PLACEHOLDER' | translate">
    </ion-input>
  </ion-item>

  <ion-item>
    <label>{{ 'COMPANY.OWNER' | translate }}</label>
    <ion-grid class="first-and-last">
      <ion-row class="owner-inputs">
        <ion-col size="12" size-md="6">
          <ion-input 
            class="ion-text-right"
            formControlName="first_name"
            [label]="'COMPANY.FIRST_NAME' | translate"
            [placeholder]="'COMPANY.FIRST_NAME_PLACEHOLDER' | translate">
          </ion-input>
        </ion-col>
        <ion-col size="12" size-md="6">
          <ion-input
            formControlName="last_name"
            [label]="'COMPANY.LAST_NAME' | translate"
            [placeholder]="'COMPANY.LAST_NAME_PLACEHOLDER' | translate">
          </ion-input>
        </ion-col>
      </ion-row>
    </ion-grid>
  </ion-item>

  <!-- <ion-item>
    <ion-input
      class="ion-text-right"
      formControlName="weekly_summary"
      label="Weekly Summaries"
      type="checkbox">
    </ion-input>
  </ion-item> -->

  <h6>{{ 'COMPANY.MAILING_ADDRESS' | translate }}</h6>
  <ion-item>
    <label>{{ 'COMPANY.COUNTRY' | translate }}</label>
    <select formControlName="country" class="small" [attr.aria-label]="'COMPANY.COUNTRY' | translate">
      <option *ngFor="let c of countries" [value]="c.code">{{ c.name || ('COMPANY.COUNTRY' | translate) }}</option>
    </select>
  </ion-item>

  <ion-item>
    <ion-input
      class="ion-text-right"
      formControlName="line_one"
      [label]="'COMPANY.LINE_1' | translate"
      [placeholder]="'COMPANY.ADDRESS_LINE_1' | translate">
    </ion-input>
  </ion-item>

  <ion-item>
    <ion-input
      class="ion-text-right"
      formControlName="line_two"
      [label]="'COMPANY.LINE_2' | translate"
      [placeholder]="'COMPANY.ADDRESS_LINE_2' | translate">
    </ion-input>
  </ion-item>

  <ion-item>
    <ion-input
      class="ion-text-right"
      formControlName="city"
      [label]="'COMPANY.CITY' | translate"
      [placeholder]="'COMPANY.CITY_PLACEHOLDER' | translate">
    </ion-input>
  </ion-item>

  <ion-item *ngIf="isUS()">
    <label>{{ 'COMPANY.STATE' | translate }}</label>
    <select formControlName="state" class="small" [attr.aria-label]="'COMPANY.STATE' | translate">
      <option *ngFor="let st of getStates()" [value]="st.abbreviation">{{ st.name }} ({{ st.abbreviation }})</option>
    </select>
  </ion-item>
  <ion-item *ngIf="!isUS()">
    <ion-input
      class="ion-text-right"
      formControlName="state"
      [label]="'COMPANY.STATE_PROVINCE_REGION' | translate"
      [placeholder]="'COMPANY.STATE_PROVINCE_REGION' | translate">
    </ion-input>
  </ion-item>

  <ion-item>
    <ion-input
      class="ion-text-right"
      formControlName="postal_code"
      [label]="(isUS() ? ('COMPANY.ZIP_CODE' | translate) : ('COMPANY.POSTAL_CODE' | translate))"
      [placeholder]="'COMPANY.POSTAL_CODE_PLACEHOLDER' | translate">
    </ion-input>
  </ion-item>
</form>

<ion-row class="ion-justify-content-end ion-padding-end">
  <ion-button type="submit"
    [disabled]="!isValid() || !canAdminister"
    (click)="save()" *ngIf="!updatePending">{{ 'COMPANY.SUBMIT' | translate }}</ion-button>
  <div *ngIf="updatePending" class="submitpending">
    <ion-spinner name='bubbles'></ion-spinner>
    <span>{{ 'COMPANY.UPDATING' | translate }}</span>
  </div>
</ion-row>

<p class="company-switch-account-hint ion-padding-horizontal ion-text-wrap" role="note">
  <span class="company-switch-account-hint-prefix">{{ 'COMPANY.SWITCH_ACCOUNT_HINT_PREFIX' | translate }}</span><button
    type="button"
    class="company-switch-account-hint-link"
    (click)="goToSwitchAccounts()"
  >{{ 'COMPANY.SWITCH_ACCOUNT_HINT_LINK' | translate }}</button>
</p>